import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ConexContext from '../../context/ConexContext';

const ModalCambioPass = (props) => {
	const { peticion } = useContext(ConexContext);
	const { usuario, clave } = useParams();

	const [contraseñaActual, setContraseñaActual] = useState(''); //contraseña actual
	const [nuevaContraseña, setNuevaContraseña] = useState(''); //nueva contraseña
	const [confirmacionContraseña, setConfirmacionContraseña] = useState(''); //confirmación de la nueva contraseña

	const [error, setError] = useState(''); //mostrar mensajes
	const [cambioOk, setCambioOk] = useState(false); //cambiar el modal y mostrar que ha cambiado la contraseña

	/**
	 * Comprueba que las contraseñas sean correctas y las cambia
	 */
	const cambioPass = async () => {
		// comprobamos que los campos no estén vacíos
		if (contraseñaActual === '' || nuevaContraseña === '' || confirmacionContraseña === '') {
			setError('Debes rellenar todos los campos')
			return
		}
		// comprobamos que la nueva contraseña y la confirmación coincidan
		if (nuevaContraseña !== confirmacionContraseña) {
			setError('Las contraseñas no coinciden')
			return
		}
		// comprobamos que la nueva contraseña no sea igual a la actual
		if (nuevaContraseña === contraseñaActual) {
			setError('La nueva contraseña no puede ser igual a la actual')
			return
		}
		// comprobamos longitudes
		if (nuevaContraseña.length < 8) {
			setError('La contraseña debe tener al menos 8 caracteres')
			return
		}
		if (nuevaContraseña.length > 20) {
			setError('La contraseña no puede tener más de 20 caracteres')
			return
		}
		//comprobar que contenga al menos una letra mayuscula, una minuscula y un número
		if (!/[A-Z]/.test(nuevaContraseña) || !/[a-z]/.test(nuevaContraseña) || !/[0-9]/.test(nuevaContraseña)) {
			setError('La contraseña debe contener al menos una letra mayúscula, una minúscula y un número')
			return
		}

		//aqui todo está correcto, se manda a cambiar la contraseña
		setError('')
		let res;
		if (props.validar) //si es para validar usuario
			res = await peticion(`/validar_usuario`, {
				method: 'POST', json: {
					"validar": contraseñaActual,
					"pass": nuevaContraseña,
					"reppass": confirmacionContraseña,
					"usuario": usuario
				}
			});
		else //si es para cambiar la contraseña de un usuario
			res = await peticion(`/cambiar_pass`, {
				method: 'POST', json: {
					"vieja": contraseñaActual,
					"nueva": nuevaContraseña,
					"repetida": confirmacionContraseña,
					"usuario": usuario
				}
			});
			
		if (res?.estado ?? true) return setError('Se ha producido un error'); //error
		if (res?.mensaje !== 'OK' ?? false) return setError(res?.mensaje ?? 'Error al cambiar la contraseña'); //errores
		setCambioOk(true)
	}

	//cada vez que se abre o cierra el modal, se resetean los campos
	useEffect(() => {
		if (props.show && props.validar) 
			setContraseñaActual(clave)
		else
			setContraseñaActual('')
		setNuevaContraseña('')
		setConfirmacionContraseña('')
		setError('')
		setCambioOk(false)
	}, [props.show, props.validar, clave])

	if (!props.show)
		return ("")
	else
		return (
			<Modal
				className="modal_campos"
				show={props.show}
				onHide={props.onHide}
				animation={false}
				centered
				size="lg"
			>
				<div id="modalcambiopass">
					<Modal.Body>
						<h2>Cambiar contraseña</h2>
						{!cambioOk ?
							<form>
								{!props.validar &&
									<div className='form-item' id='current-pass'>
										<label>Contraseña actual</label>
										<input
											type='password'
											placeholder='Contraseña actual'
											value={contraseñaActual}
											onChange={(e) => setContraseñaActual(e.target.value)}
											disabled={props.validar}
										/>
									</div>
								}
								<div className='form-item' id='new-pass'>
									<label>Nueva contraseña</label>
									<input
										type='password'
										placeholder='Nueva contraseña'
										value={nuevaContraseña}
										onChange={(e) => setNuevaContraseña(e.target.value)}
									/>
								</div>
								<div className='form-item' id='repeat-pass'>
									<label>Repite contraseña</label>
									<input
										type='password'
										placeholder='Repite contraseña'
										value={confirmacionContraseña}
										onChange={(e) => setConfirmacionContraseña(e.target.value)}
									/>
								</div>
							</form>
							:
							<div>
								<p>Contraseña cambiada correctamente.</p>
								{props.validar &&
									<p>Ya puedes iniciar sesión con {usuario}</p>
								}
							</div>
						}

					</Modal.Body>
				</div>

				<Modal.Footer>
					<p>{error}</p>
					<div className='button-container'>
						{!cambioOk ?
							<>
								{!props.validar &&
									<button
										onClick={() => {
											props.onHide();
										}}
									>
										Cancelar
									</button>
								}
								<button className='cta'
									onClick={() => { cambioPass(); }}
								>
									Aplicar
								</button>
							</>
							:(props.validar ?
									<button className='cta'
										onClick={() => { props.onHide(); }}
									>
										Iniciar sesión
									</button>
								:
									<button
										onClick={() => { props.onHide(); }}
									>
										Cerrar
									</button>
							)
						}
					</div>
				</Modal.Footer>
			</Modal>
		)
}

export default ModalCambioPass